export const ENV_STRAPI_URL = process.env.NEXT_PUBLIC_STRAPI_URL;

export const ENV_PAGE_BASE_URL = process.env.NEXT_PUBLIC_BASE_PATH;

export const ENV_APP_ENV = process.env.NEXT_PUBLIC_APP_ENV;

export const NEXT_PUBLIC_IMAGE_TRACKING = process.env.NEXT_PUBLIC_IMAGE_TRACKING;
